module.exports = __webpack_public_path__ + "img/tablet-neck-3_350x35.ea8b335a.png";